import React from 'react';
import { useLocation } from 'react-router-dom';
import { routes } from 'routes/routes';

const useHistoryState = () => {
   // todo move hook call to app.tsx
   const pagesToSkipOnBack = [
      {
         route: routes().newflow1.matchingAnimation,
         previousPathToTriggerRedirect: routes().newflow1.portfolio,
      },
      {
         route: routes().newflow1.planbuildingAnimation,
         previousPathToTriggerRedirect: routes().newflow1.signup,
      },
      { route: routes().generatePage, previousPathToTriggerRedirect: routes().portfolio },
   ];
   const location = useLocation();
   const setPreviousPath = (path: string) => {
      sessionStorage.setItem('previousPath', path);
   };

   const getPreviousPath = () => {
      return sessionStorage.getItem('previousPath');
   };

   const handlePathChange = () => {
      const previousPath = getPreviousPath();
      const currentPath = location.pathname;
      const currentPageToSkip = pagesToSkipOnBack.find((page) => currentPath.includes(page.route));
      if (previousPath && currentPageToSkip) {
         const currentPageShouldBeSkipped =
            currentPath.includes(currentPageToSkip.route) &&
            previousPath.includes(currentPageToSkip.previousPathToTriggerRedirect);
         if (currentPageShouldBeSkipped) {
            window?.history.back();
         } else setPreviousPath(currentPath);
      } else {
         setPreviousPath(currentPath);
      }
   };

   return { handlePathChange };
};
export default useHistoryState;
